import api from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindAuditoriaRelatoriosDto, AuditoriaRelatorioDto } from './auditoria-relatorios.types';

export async function GetAuditoriaRelatorios(filters: FindAuditoriaRelatoriosDto) {
  filters.skip ??= 0;
  filters.take ??= 10;
  const response = await api.get<[AuditoriaRelatorioDto[], number]>(Endpoints.AUDITORIA_RELATORIOS, {
    params: filters,
  });
  return response.data;
}
